import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { v4 as uuidV4 } from 'uuid'

import { initialState } from './constants'
import { Notification, NotificationAction } from './types'

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    sendNotification: (state, action: PayloadAction<NotificationAction>) => {
      const payload: Notification = {
        id: uuidV4(),
        ...action.payload,
      }
      state.notifications = [
        payload,
        ...state.notifications.filter(({ id }) => id !== payload.id),
      ]
    },
    dismissNotification(state, action: PayloadAction<string>) {
      state.notifications = state.notifications.filter(
        (x) => x.id !== action.payload
      )
    },
    clearNotifications(state) {
      state.notifications = initialState.notifications
    },
  },
})

export const { sendNotification, dismissNotification, clearNotifications } =
  notificationsSlice.actions
export const notificationsReducer = notificationsSlice.reducer
